import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import {FaultWritingReportConfig} from '../faults-writing-report.config';
import {MmFaultsWritingReportingService} from '../mm-fault-writing-reporting.service';
import {MediaQueryService} from '@mydocma/core';
import {FaultsWritingStepperComponent} from '../faults-writing-stepper/stepper/faults-writing-stepper.component';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {StepNextMethodEnum} from '../faults-writing-stepper/steps/step-next-method.enum';
import {StepButtonTypeEnum} from '../faults-writing-stepper/steps/step-button-type.enum';
import {WritingPreviewService} from '../faults-writing-stepper/services/writing-preview.service';
import {AppContainerService} from "@mydocma/app-container";

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-writing-dialog',
  templateUrl: './faults-writing-dialog.component.html',
  styleUrls: ['./faults-writing-dialog.component.scss'],
  providers: [ WritingPreviewService ]
})
export class FaultsWritingDialogComponent implements OnInit, AfterViewInit {
  mobileMode: boolean;

  @ViewChild('stepperComponent', { static: false })
  private stepperComponent: FaultsWritingStepperComponent;

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: {config: FaultWritingReportConfig, service: MmFaultsWritingReportingService},
              public readonly mediaQueryService: MediaQueryService,
              public appContainerService: AppContainerService,
              private readonly previewEmailBodyService: WritingPreviewService) {
  }

  ngOnInit() {  }

  ngAfterViewInit() {
    if (this.stepperComponent) {
      this.stepperComponent.stepperService$
        .pipe(untilDestroyed(this))
        .subscribe(service => {
          this.dialogData.service.steperService = service;
        });
    }
  }

  onResize(event) {
    this.mobileMode = event.contentRect.width <= 600;
  }

  async previewEmailBody() {
    this.dialogData.service.nextSubject.next(StepNextMethodEnum.PreviewEmailBody);
  }

  async cancel() {
    this.dialogData.service.cancelReportConfiguration(this.dialogData.config);
  }

  async next() {
    switch (this.dialogData.service.ButtonDefinitions.get(StepButtonTypeEnum.Next).Method) {
      case StepNextMethodEnum.Next:
        this.dialogData.service.nextSubject.next(null);
        const nextStepName = this.dialogData.service.ButtonDefinitions.get(StepButtonTypeEnum.Next).Args;
        if (!nextStepName) {
          await this.dialogData.service.steperService.nextStep();
        }
        else {
          await this.dialogData.service.steperService.nextStep(nextStepName);
        }
        break;

      case StepNextMethodEnum.Print:
        this.dialogData.service.nextSubject.next(StepNextMethodEnum.Print);
        break;

      case StepNextMethodEnum.Send:
        this.dialogData.service.nextSubject.next(StepNextMethodEnum.Send);
        break;
    }
  }
}
